export default __webpack_public_path__ + "static/swedbank-3e9f8fbc02566553b718a3a0e92eaaf5.png";